import { modifyLinkBehavior } from '../utils.js';

export default function hotButtons() {
  const widgetName = 'hotButtonsWidget';
  const widgetOpts = hotButtonsWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (hasData) {
        modifyLinkBehavior(data, cards);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 6,
    moreButton: {
      visible: true,
      text: 'More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
